import { defineMessages } from 'react-intl';

const cookiePreferencesMessages: {
	cookiePreferences: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	cookiePreferences: {
		id: 'hub.cookie-preferences-button.cookiePreferences',
		defaultMessage: 'Cookie preferences',
		description:
			'Label for a button that opens a modal where users can review and change their cookie and privacy preferences.',
	},
});
export default cookiePreferencesMessages;
